import { connect, Component, Rendering } from "macguffin"
import GameMode from "game/modes"
import { Tween } from "@tweenjs/tween.js"

const FONT_SCALE = 0.5
const COUNTDOWN_ANIMATION = "pulseCountdown 0.5s 2 alternate"
const COUNTDOWN_DELAY = 1000
const COUNTDOWN_DURATION = 1000
const COUNT_DOWN_FROM = 5

@connect(state => ({
    currentGameMode: state.game.currentGameMode
}), {})
export default class Countdown extends Component {
    state = {}

    componentWillReceiveProps(nextProps) {
        const { props: currentProps, countDown } = this
        if (nextProps.currentGameMode !== currentProps.currentGameMode && nextProps.currentGameMode === GameMode.BONUS_COUNTDOWN) {
            new Tween()
                .to({}, COUNTDOWN_DELAY)
                .onComplete(() => {
                    countDown(COUNT_DOWN_FROM)
                })
                .start()
        }
    }

    countDown = (count) => {
        const { countDown } = this

        if (count < 0) {
            return
        }

        this.setState({ count }, () => {
            new Tween()
                .to({}, COUNTDOWN_DURATION)
                .onComplete(() => {
                    countDown(count - 1)
                })
                .start()
        })
    }

    render() {
        const { props:{ height }, state:{count} } = this

        const style = {
            fontSize: height * FONT_SCALE,
            animation: COUNTDOWN_ANIMATION
        }

        return <div className="countdownOverlay">
            { !!count && <h1 key={`Countdown: ${count}`} style={style}>{count}</h1> }
        </div>
    }
}
